module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"workspace":"Workspace","search":"Search"},"th":{"workspace":"เวิร์คสเปซ","search":"ค้นหา"}}')
  delete Component.options._Ctor
}
